import axios from 'axios';
import BaseAPI from './base/base-api';

class ReportAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'report';
}

export default new ReportAPI();